import { Editor } from "@tiptap/react";
import { useEffect, useState } from "react";
import BulletListIcon from "../../../../assets/icon/CampaignNotesToolbar/BulletListIcon";
import OrderedListIcon from "../../../../assets/icon/CampaignNotesToolbar/OrderedListIcon";
import EditToolbarButton from "./EditToolbarButton";

interface ListButtonProps {
  editor: Editor;
}

export default function ListButton({ editor }: ListButtonProps) {
  const [listType, setListType] = useState(0);

  useEffect(() => {
    if (editor) {
      switch (listType) {
        case 1:
          editor
            .chain()
            [
              `toggle${
                "bulletList".charAt(0).toUpperCase() + "bulletList".slice(1)
              }`
            ]()
            .run();
          break;
        case 2:
          editor
            .chain()
            [
              `toggle${
                "orderedList".charAt(0).toUpperCase() + "orderedList".slice(1)
              }`
            ]()
            .run();
          break;
        default:
          break;
      }
    }
  }, [listType, editor]);

  const handleClick = () => {
    setListType((prevType) => (prevType === 2 ? 0 : prevType + 1));
  };

  return (
    <EditToolbarButton
      onClick={handleClick}
      editor={editor}
      tooltipId="list"
      tooltipText="List"
      isActive={listType !== 0}
    >
      {(listType === 0 || listType === 1) && <BulletListIcon />}
      {listType === 2 && <OrderedListIcon />}
    </EditToolbarButton>
  );
}
